module.exports = __webpack_public_path__ + "img/Frame 5128.82b4708f.jpg";